import TextMaxLengthView from "./TextMaxLengthView";
import * as lodash from 'lodash';

type ListOfNamesViewProps = {
    data: number[] | string[] | undefined
    maxlength?: boolean | number
    distinct?: boolean
}

const ListOfNamesView = (props: ListOfNamesViewProps) => {
    if(!props.data?.length) return <></>;
    const max = typeof props.maxlength == 'number' ? props.maxlength : undefined;
    let data = [...props.data];
    if(props.distinct) {
        data = lodash.uniq(data);
    }
    return <ul>
        {data.map(x => {
            return <li key={x.toString()}>
                {props.maxlength ? <TextMaxLengthView text={x.toString()} max={max} /> : x}
            </li>
        })}
    </ul>
}

export default ListOfNamesView;
